<template>
  <ViolationForm />
</template>
<script>
import ViolationForm from './ViolationForm.vue'

export default {
  components: { ViolationForm },
}
</script>
